"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var warning_1 = __importDefault(require("warning"));

var Avatar_1 = __importDefault(require("@material-ui/core/Avatar"));

var styles_1 = require("@material-ui/core/styles");

var functions_1 = require("./libUtils/functions");

var clsx_1 = __importDefault(require("clsx"));

var styles = function styles(_ref) {
  var palette = _ref.palette;
  return styles_1.createStyles({
    colorDefault: {
      backgroundColor: palette.grey[300],
      color: palette.grey[800]
    },
    colorInherit: {
      backgroundColor: 'inherit',
      color: 'inherit'
    },
    colorPrimary: {
      backgroundColor: palette.primary.main,
      color: palette.primary.contrastText
    },
    colorSecondary: {
      backgroundColor: palette.secondary.main,
      color: palette.secondary.contrastText
    },
    sizeXsmall: {
      width: '24px',
      height: '24px',
      fontSize: '16px',
      fontWeight: 'bold'
    },
    sizeSmall: {
      width: '32px',
      height: '32px'
    },
    sizeLarge: {
      width: '56px',
      height: '56px',
      fontSize: '32px'
    },
    sizeInherit: {
      '& svg': {
        fontSize: 'inherit !important'
      }
    },
    root: {},
    img: {}
  });
};

var avatarErrors = function avatarErrors(props) {
  var alt = props.alt,
      children = props.children,
      src = props.src;

  if (src) {
    warning_1.default(alt, 'Unifi: Avatar presenting as an image requires alt text. For a working, accessible example, see https://unifi.nelnet.io/components/content/avatars/#image-avatars');
  }

  if (React.Children.count(children) === 1 && typeof children === 'object') {
    warning_1.default(props['aria-label'], 'Unifi: Icon-only Avatar requires an aria-label prop. For a working, accessible example, see https://unifi.nelnet.io/components/content/avatars/#icon-avatars');
  }
};

var Avatar = function Avatar(_a) {
  var className = _a.className,
      classes = _a.classes,
      color = _a.color,
      size = _a.size,
      style = _a.style,
      _a$variant = _a.variant,
      variant = _a$variant === void 0 ? 'circle' : _a$variant,
      props = __rest(_a, ["className", "classes", "color", "size", "style", "variant"]);

  avatarErrors(props);
  var avatarColor = functions_1.convertNeutralColor(color);
  var rootClasses = clsx_1.default(className, color !== 'initial' && avatarColor && classes["color" + functions_1.capitalize(avatarColor)], typeof size === 'string' && size !== 'medium' && classes["size" + functions_1.capitalize(size.replace('-', ''))], (typeof size === 'object' || typeof size === 'string' && ['x-small', 'large'].includes(size)) && classes.sizeInherit, classes.root, classes.img);
  var sizeStyles = style;

  if (typeof size === 'object' && size !== null) {
    var width = size.width,
        height = size.height;
    var heightInt = height !== null && height !== void 0 ? height : '0';
    var avatarWidth = (width || height) && parseInt(width ? width : heightInt, 10);
    var fontSize = avatarWidth && avatarWidth > 56 ? Math.ceil(avatarWidth * 0.6) : undefined;
    sizeStyles = Object.assign(Object.assign({
      fontSize: fontSize
    }, style), {
      width: width ? width : height,
      height: height ? height : width
    });
  }

  return React.createElement(Avatar_1.default, Object.assign({}, props, {
    variant: variant,
    className: rootClasses,
    style: sizeStyles
  }));
};

exports.default = styles_1.withStyles(styles)(Avatar);